import { Box, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useDataProvider, useRedirect } from 'react-admin';
import { getFieldByTitle } from '../../helpers/sortByTitle';
import { Order } from '../../types/order';
import PaginationTable from '../common/paginationTable';
import HeadTable from '../common/sortTable/sortTable';

interface Props {
    prize: string;
    isActive: boolean;
    competitionType: string;
    competitionId: string
}

interface OrderDetails {
    name: string;
    surname: string;
    tickets: number;
    _id: string;
    userId: string
}

const TicketsDetails: FC<Props> = ({ prize, isActive, competitionType, competitionId }) => {
    const dataProvider = useDataProvider()
    const redirect = useRedirect()

    const [state, setState] = useState({
        orders: Array<OrderDetails>(),
        total: 0,
        page: 1,
        perPage: 10,
        field: '_id',
        order: 'desc',
    })

    useEffect(() => {
        getOrders(1, 10, '_id', 'asc')
    }, [])

    const getOrders = async (page, perPage, field, order) => {
        const result = await dataProvider.getOrders({
            filter: {
                prize: prize,
                type: competitionType,
                isActive: isActive,
                id: competitionId
            },
            pagination: { page: page, perPage: perPage },
            sort: { field: field, order: order }
        }) as any
        setState({
            ...state,
            total: result.data.allCount,
            orders: result.data.result,
            page: page,
            perPage: perPage,
            field: field,
            order: order
        })
    }

    const handleSort = (direct: string, title: string) => {
        const field = getFieldByTitle(title).toLowerCase()
        getOrders(state.page, state.perPage, field, direct)
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const perPage = parseInt(event.target.value, 10)
        getOrders(1, perPage, state.field, state.order)
    }

    const handleLastPage = () => {
        const page = Math.ceil(state.total / state.perPage)
        getOrders(page, state.perPage, state.field, state.order)
    }

    const handleFirstPage = () => {
        getOrders(1, state.perPage, state.field, state.order)
    }

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number): void => {
        getOrders(newPage + 1, state.perPage, state.field, state.order)
    };

    const toUser = (id: string) => {
        redirect(`/users/${id}`)
    }

    return (
        <>
            <Box marginTop="0.5em">
                <Box display="flex" paddingBottom="1em" justifyContent="center">
                    <Typography variant="h6" className="base-color">
                        Tickets details
                    </Typography>
                </Box>
                <Card>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell id="status-table-head-actions">
                                        <HeadTable title="First name" sort={handleSort} />
                                    </TableCell>
                                    <TableCell id="active-table-head">
                                        <HeadTable title="Last name" sort={handleSort} />

                                    </TableCell>
                                    <TableCell id="active-table-head">
                                        <HeadTable title="Tickets" sort={handleSort} />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            {
                                state.orders.map((item) => {
                                    return (
                                        <TableBody >
                                            <TableCell>
                                                <div className="move-search-user" onClick={() => toUser(item.userId)}>{item.name}</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="move-search-user" onClick={() => toUser(item.userId)}>{item.surname}</div>
                                            </TableCell>
                                            <TableCell>
                                                {item.tickets}
                                            </TableCell>


                                        </TableBody>
                                    )
                                })
                            }
                        </Table>
                    </TableContainer>
                    <PaginationTable
                        page={state.page}
                        perPage={state.perPage}
                        collectionLength={state.orders.length}
                        total={state.total}
                        handleChangePage={handleChangePage}
                        handleLastPage={handleLastPage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        handleFirstPage={handleFirstPage}
                        title="Users"
                    />
                </Card>
            </Box>
        </>
    )
}

export default TicketsDetails